import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Topbar from '../components/Topbar';
import Sidebar from "../components/Sidebar";
import VoucherRedemptionCard from "../../../admin/components/report/VoucherRedemptionCard";

const VoucherRedemption = ({ token, client }) => {
    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!client || !client.voucher_redemption) {
            history.push('/client')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <VoucherRedemptionCard
                        role="client"
                        token={token}
                        operators={client.admin}
                        distributors={client.distributor}
                        outlets={client.outlet}
                        tokenSetting={client.token}
                        stamp={client.stamp}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(VoucherRedemption);
